export default __webpack_public_path__ + "static/media/hair_prop.77173920.svg";